import React from "react";
import Layout from "../components/Layout";
import { styled } from "styled-components";

export default function Cookiepolicy() {
  return (
    <Layout>
      <CookieHeader>
        <H1>Cookie policy</H1>
      </CookieHeader>
      <CookieInfo>
        <p>
          {" "}
          This Cookie Policy explains how cookies, pixels,&nbsp; and similar
          technologies (together "cookies") are used by Standard Chartered Group
          ("SCB", "we" or "our").&nbsp; By using our website you agree to the
          use of cookies as outlined in this policy. Please disable cookies on
          your computer or do not use our website if you do not wish to accept
          cookies from us.
        </p>
        <br />
        <H3>What are Cookies</H3>
        <p>
          {" "}
          Cookies are small data files which are placed on your Device when you
          visit certain parts of our website or click on our online
          advertisements. We use the following cookies:{" "}
        </p>
        <p>
          {" "}
          <strong>Strictly necessary cookies</strong> are required for the
          operation of our website by:{" "}
        </p>
        <ul>
          <li>
            allowing our web server to determine whether the cookies setting on
            your web browser have been enabled or disabled. This allows us to
            know whether data can be collected from your web browser{" "}
          </li>
          <li>
            {" "}
            temporarily allowing you to carry information between pages of our
            Website to avoid having to re-enter that information{" "}
          </li>
          <li>
            {" "}
            temporarily identifying your device after you have logged in to a
            secure page on our Website so that our web server can maintain a
            dialogue with your web browser in order for you to carry out certain
            activities.{" "}
          </li>
        </ul>
        <p>
          {" "}
          <strong>Analytical/performance cookies</strong> are used to help us
          improve our website by tracking your visits to our website and
          recognising your web browser when you are a repeat visitor so that we
          can gather statistics on new and repeat visitors to evaluate site
          effectiveness.{" "}
        </p>
        <p>
          {" "}
          <strong>Functionality cookies</strong> are used to recognise you when
          you return to our Website. This enables us to:{" "}
        </p>{" "}
        <ul>
          {" "}
          <li>
            {" "}
            remember the choices you make (such as your user name, language and
            region) so you do not have to re-enter that information when you
            return to our Website
          </li>
          <li>personalise our website content for you.</li>
        </ul>
        <p>
          {" "}
          <strong>Targeting/advertising cookies</strong> record your visit to
          our website, your response to our online advertisements, track the
          pages you have visited and the website links you have followed. We use
          this information to:{" "}
        </p>
        <ul>
          <li>
            <div>
              {" "}
              make our website more relevant to your interests based on your
              past visits to our website{" "}
            </div>
          </li>
          <li>
            {" "}
            <div>
              {" "}
              tailor our online advertisements or offers on our or third party
              websites to those which are most likely to be of interest to you{" "}
            </div>{" "}
          </li>
          <li>
            {" "}
            <div>
              {" "}
              evaluate the effectiveness of our online marketing and advertising
              campaigns.{" "}
            </div>
          </li>
        </ul>
        <p>
          {" "}
          The above cookies may be placed on your Device by us or by third
          parties on our behalf, such as Google, DoubleClick and Facebook.{" "}
        </p>
        <br />
        <H3>Fraud prevention</H3>
        <p>
          {" "}
          We may also use the above mentioned cookies to assist us in fraud
          prevention.{" "}
        </p>
        <br />
        <H3>How to disable cookies</H3>
        <p>
          {" "}
          Most web browsers are initially set up to accept cookies. You can
          choose to not accept cookies by changing the settings on your web
          browser but if you block all cookies, including strictly necessary
          cookies, you may find that certain features on our Website will not
          work properly.{" "}
        </p>
        <p>
          {" "}
          You can choose not to accept third party cookies through your browser
          settings.{" "}
        </p>
        <p>
          {" "}
          You can opt out of Google's use of cookies by visiting Google's Ad
          Settings , DoubleClick's use of cookies by visiting the DoubleClick
          opt-out page and Facebook's use of pixel information on Facebook's Ad
          settings.{" "}
        </p>
        <p>
          {" "}
          You can also visit the following sites to check and select your
          preferences for online ads:{" "}
        </p>
        <ul>
          <li>
            {" "}
            <a
              rel="noopener noreferrer"
              title="Digital Advertising Alliance"
              href="https://www.aboutads.info/choices/"
              target="_blank"
            >
              {" "}
              Digital Advertising Alliance{" "}
            </a>{" "}
          </li>
          <li>
            {" "}
            <a
              rel="noopener noreferrer"
              title="Network Advertising Initiative"
              href="https://www.networkadvertising.org/choices/"
              target="_blank"
            >
              {" "}
              Network Advertising Initiative{" "}
            </a>{" "}
          </li>
          <li>
            {" "}
            <a
              rel="noopener noreferrer"
              title="Internet Advertising Industry"
              href="https://www.youronlinechoices.com/"
              target="_blank"
            >
              {" "}
              Internet Advertising Industry{" "}
            </a>{" "}
          </li>
        </ul>
        <br />
      </CookieInfo>
    </Layout>
  );
}

const CookieHeader = styled.header`
  background: linear-gradient(90deg, rgb(44, 58, 136) 0%, rgb(0, 97, 200) 100%);
  padding: 2rem 12rem;
`;

const H1 = styled.h1`
  color: rgb(255, 255, 255);
  font-family: "SC Prosper Sans";
  font-size: 2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 5.6rem;
`;

const H3 = styled.h3`
  color: rgb(42, 45, 48);
  font-size: 1.8rem;
  margin-bottom: 1rem;
  font-weight: 500;
  line-height: 1.2;
`;

const CookieInfo = styled.article`
  padding: 2rem 12rem 4rem;
  color: rgb(42, 45, 48);
  font-family: Inter;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  letter-spacing: 0px;

  p {
    color: rgb(42, 45, 48);
    margin: 1.6rem 0px;
    text-align: left;
    font-family: Inter;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: 0px;
  }

  ul {
    list-style-type: disc !important;
    list-style-position: outside !important;
    margin-left: 1.5rem !important; /* Ensure there is space for the dots */
    padding-left: 1rem !important; /* Add padding to ensure dots are visible */
  }

  li {
    margin: 0.4rem 0px;
    padding-left: 6px;
    font-family: Inter;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: 0px;
    list-style-type: disc !important;
    list-style-position: outside !important;
  }
`;
